export default __webpack_public_path__ + "9deab3811e118a2c69821789b9192f5d.svg";